angular.module('app', [

    //third party
    'angularLocalStorage',
    'gettext',
    'lodash',
    'ngAnimate',
    'ngTouch',
    'restangular',
    'toaster',
    'ui.bootstrap',
    'ui.router',
    'ui.router.upgrade',
    'ngIdle',

    //aprima
    'account',
    'apEasyScroller',

    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common',
    'aprima-provider-api',
    'aprima-patient-api'
]).constant('AppId', {
        MessageSubHeader: 'B348F800-1FCB-4397-9E1A-2226AFD836E4',
        PracticeName: '2AD081A3-A195-4093-9C7F-1563BD3179A3',
        PracticeTagline: '72AF95CE-12F5-450A-8C0A-3941A3256AC7',
}).config(['IdleProvider', function(IdleProvider) {
    'use strict';


    // Application timeout logic is in the following locations :
    // =======================================================
    // 1 - modules\app\app.js
    //       ng-idle configuration and links to documentation are located here.
    //
    // 2 - modules\app\controllers\LoginCtrl.js
    //       After user logs in, IdleStartWatch is broadcast to start application timeout.
    //       Listener is located in modules\common\init.js
    //
    // 3 - modules\common\init.js
    //       IdleStartWatch listener.  Event is broadcast from LoginCtrl.js once user is logged in.  Idle.watch() is called here.
    //       IdleTimeout listener.  fires when IdleProvider.idle() + IdleProvider.timeout() expire.  Log out logic is located here.
    //
    // 4 - ng-idle documentation can be found at the following locations
    //       http://hackedbychinese.github.io/ng-idle/
    //       https://github.com/HackedByChinese/ng-idle/wiki/Idle-and-Idleprovider
    //       https://github.com/HackedByChinese/ng-idle/wiki


    // List of DOM events the Idle service will watch to reset the idle timeout
    // IdleProvider.interrupt('mousemove keydown DOMMouseScroll mousewheel mousedown')
    IdleProvider.interrupt('keydown mousedown mousewheel');    // Exclude mousemove DOM event.  ng-idle has bug with mousemove.

    IdleProvider.autoResume(true);   // FALSE - you will need to manually call watch() to start watching for idleness
    IdleProvider.keepalive(false);    // FALSE - turn off keepalive

    // The idle timeout duration in seconds.  After this amount of time passes without the user
    // performing an action that triggers one of the watched DOM events, the user is considered
    // idle.  Default is 20 minutes.
    IdleProvider.idle(600); // Set timeout to 10 minutes (60*10)

    // The amount of time the user has to respond (in seconds) before they have been considered timed out.
    // Set to 0 or false to disable this feature.  Default is 30 seconds.
    IdleProvider.timeout(1);
}]);
